import type { AutocompleteItem } from '../../autocomplete/index'
import AppStore from '~publish/legacy/composer/composer/stores/AppStore'
import { selectedChannelsForTracking } from '~publish/legacy/composer/composer/editor/ComposerEditor/hooks/useSelectedChannelsForTracking'

export function getLocalStorageKey(): string {
  const orgId = AppStore.getOrganizationId()

  return `linkedin-annotation-selected-${orgId}`
}

export function getRecentItems(): AutocompleteItem[] | null {
  const recentItems = localStorage.getItem(getLocalStorageKey())

  if (recentItems) {
    try {
      return JSON.parse(recentItems).map((item: AutocompleteItem) => {
        return {
          ...item,
          data: {
            ...item.data,
            recentItem: true,
          },
        }
      }) as AutocompleteItem[]
    } catch (error) {
      return null
    }
  }

  return null
}

export function removeRecentItem(itemKey: string): boolean {
  const localStorageKey = getLocalStorageKey()
  const recentItems = localStorage.getItem(localStorageKey)
  if (recentItems) {
    try {
      const updatedItems = JSON.parse(recentItems).filter(
        (item: AutocompleteItem) => item.key !== itemKey,
      ) as AutocompleteItem[]

      localStorage.setItem(
        localStorageKey,
        JSON.stringify(updatedItems.slice(0, 3)),
      )

      return true
    } catch (error) {
      return false
    }
  }

  return false
}

export function isRecentItem(itemKey: string): boolean {
  const recentItems = getRecentItems()
  return Boolean(recentItems?.some((item) => item.key === itemKey))
}

export function onSelectItem(item: AutocompleteItem): void {
  const recentItems = getRecentItems() || []
  const items = [item, ...recentItems]
  const deduplicated = new Map(items.map((item) => [item.key, item]))

  const trackingDetails = selectedChannelsForTracking({
    serviceName: 'linkedin',
  })

  if (item.data.recentItem) {
    trackingDetails.sendMentionRecentSuggestionAccepted()
  } else {
    trackingDetails.sendMentionSuggestionAccepted()
  }

  localStorage.setItem(
    getLocalStorageKey(),
    JSON.stringify([...deduplicated.values()].slice(0, 3)),
  )
}
